import { QueryStatus, TypedUseLazyQueryStateResult, TypedUseQueryHookResult } from "@reduxjs/toolkit/query/react";

import { AsyncStatus } from "../enums";

export function calculateQueriesStatus(
  queries: Array<TypedUseQueryHookResult<any, any, any> | TypedUseLazyQueryStateResult<any, any, any>>,
): AsyncStatus {
  const isRejected = queries.some((query) => query.status === QueryStatus.rejected);
  if (isRejected) {
    return AsyncStatus.FAILED;
  }

  const isUninitialized = queries.some((query) => query.status === QueryStatus.uninitialized);
  if (isUninitialized) {
    return AsyncStatus.IDLE;
  }

  const isPending = queries.some((query) => query.status === QueryStatus.pending);
  if (isPending) {
    const hasData = queries.every((query) => query.data);

    if (hasData) {
      return AsyncStatus.UPDATING;
    }

    return AsyncStatus.LOADING;
  }

  return AsyncStatus.COMPLETED;
}
